import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import Icon from 'components/icon'
import Hintable from 'components/hintable'
import iconNames from 'theme/icons'
import themeVars from 'theme/themeVars'
import './hintIcon.scss'

class HintIcon extends Component {
  constructor(props) {
    super(props)
    this.getClass = prefix('hintIcon-')
  }

  render() {
    const {
      children,
      light,
      iconColor,
      hintContent,
      hintBoxHasPointer,
      ...otherProps
    } = this.props

    return (
        <div className={this.getClass('container')}>
          <Hintable
              label={hintContent ? hintContent : children}
              light={light}
              hasPointer={hintBoxHasPointer}>
            <Icon
                name={iconNames.hint}
                color={iconColor}
                size={18}
                {...otherProps} />
          </Hintable>
        </div>
    )
  }
}

HintIcon.propTypes = {
  children: propTypes.any,
  light: propTypes.bool,
  iconColor: propTypes.string,
  hintContent: propTypes.object,
  hintBoxHasPointer: propTypes.bool,
}

HintIcon.defaultProps = {
  iconColor: themeVars.palette.disabledColor,
}

export default HintIcon
